// frontend/src/FeedbackForm.js

import React, { useState,useContext } from "react";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import {illustration} from "../../portfolio";
import "./FeedbackForm.scss"; // Optional: for styling
import StyleContext from "../../contexts/StyleContext";

function FeedbackForm() {
  const { isDark } = useContext(StyleContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [feedback, setFeedback] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch('/api/feedback.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name,
                email,
                feedback,
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    setMessage(data.error);
                } else {
                    setMessage(data.success);
                    setName('');
                    setEmail('');
                    setFeedback('');
                }
            })
            .catch(err => setMessage("Error submitting feedback: " + err.message));
    };

    return (
      <div id="feedback" className={
        isDark
          ? "dark-mode contact-subtitle"
          : "subTitle contact-subtitle"
      }> 
      <div className="feedback-form-container">
      <h2>We'd Love to Hear from You!</h2>
      <div className="contact-content">
        <div className="contact-image-div">
          <img
            alt="Man working"
            src={require("../../assets/images/contactMailDark.svg").default}
          />
        </div>
        
        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="Message">Message</label>
            <textarea
              id="Message"
              placeholder="Share your Message"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-button">
            Submit Message
          </button>
          {message && <p className="success-message">{message}</p>}
        </form>
      </div>
    </div>
    </div>
          );
        
}

export default FeedbackForm;